import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import injectSheet from 'react-jss';
import { push as routerPush } from 'react-router-redux';
import ActivityWithIconAndEdit from '../generic-components/activity-with-icon';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  contract: PropTypes.object,
  routerPush: PropTypes.func,
  companyType: PropTypes.string,
};

const styles = {
};

class CommentContract extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  jumpToContract = () => {
    const { routerPush: push, contract: { currentVersionId } } = this.props;
    const url = `/contracting/contract/${currentVersionId}/details`;
    push(url);
  }
  render() {
    const {
      contract,
    } = this.props;
    const {
      contractName,
      action,
      emailChanged,
      companyType,
    } = contract;
    const actionCheck = (() => {
      if (action === 'Created') return 'Created';
      if (action === 'Contract Created') {
        if (companyType === 'Supplier') return 'Rates Sent';
        return 'Rates Received'
      }
      if (action === 'Contract Updated') return 'Contract Updated';
      if (action === 'Request Created') return 'Request Sent';
      if (action === 'Responded') return 'Responded To Contract Request';
      if (action === 'Downloaded') return 'Downloaded Contract';
      if (action === 'Viewed') return 'Viewed Contract';
      if (action === 'Resent Contract' || action === 'Resent Request') return action;
    })();
    return (
      <div style={{ padding: '8px' }}>
        <div style={{ display: contract.diff ? 'none' : 'block' }}>
          <a style={{ marginLeft: '0.5em', cursor: 'pointer' }} onClick={this.jumpToContract}>
            {action === 'Created' && contractName.indexOf('Rate request') > -1
              ? contractName.replace('Rate request', 'Workspace')
              : contractName
            }
          </a>
          {actionCheck ? <span style={{ marginLeft: '0.5em', fontWeight: 'bold' }}>
            {actionCheck}
          </span> : undefined}
        </div>
        {
          !isNilOrEmpty(emailChanged) && (
            <div style={{ lineHeight: '20px' }}>
              Changed Email from <span style={{ color: '#00bcd4' }}>{R.path(['oldEmail'], emailChanged)}</span> to <span style={{ color: '#00bcd4' }}>{R.path(['newEmail'], emailChanged)}</span>
            </div>
          )
        }
        <ActivityWithIconAndEdit {...contract} />
      </div>
    );
  }
}

CommentContract.propTypes = propTypes;

CommentContract.defaultProps = {
  showContactLink: false,
};

const mapStateToProps = ({ user, contracting }) => ({
  isAnAdmin: user.get('isAnAdmin'),
  companyType: user.getIn(['user', 'type']),
  historyFeedId: contracting.contractActivitiesProducts.getIn(['activities', 'historyFeedId']),
});

export default connect(mapStateToProps, {
  routerPush,
})(injectSheet(styles)(CommentContract));



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/comment-contract.jsx